// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Title_wrapper__7gn6- {
    font-size: 22px;
    text-align: center;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/Tile/Title.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".wrapper {\r\n    font-size: 22px;\r\n    text-align: center;\r\n    font-weight: 600;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Title_wrapper__7gn6-`
};
export default ___CSS_LOADER_EXPORT___;
